import "./page-transition.styles.scss";

import * as React from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { useRouter } from "@montana/containers/router";
import { Timing } from "@montana/constants/animation";
import { usePage, IPageContainerState } from "@montana/containers/page";
import { FirstRenderContext } from "@montana/context/first-render.context";


const TRANSITION_DURATION = Timing.STANDARD;

const PageTransitionComponent: React.FC = (props): JSX.Element => {
    // eslint-disable-next-line react/prop-types
    const { children } = props;
    const {
        isRouting,
    } = useRouter();

    const page = usePage();

    const isFirstRender = React.useContext(FirstRenderContext);

    const [currentPage, setCurrentPage] = React.useState<IPageContainerState | null>(page);

    React.useEffect(() => {
        if (!isRouting || isFirstRender) {
            setCurrentPage(page);
        }
        if (isRouting) {
            page.setPageIsTransitioning(true);
        }
    }, [isFirstRender, page.id, isRouting]);

    const onExited = () => {
        page.setPageIsTransitioning(false);
    };

    return (
        <div className="page-transition">
            <SwitchTransition mode="out-in">
                <CSSTransition key={currentPage?.id || 0} timeout={TRANSITION_DURATION} onExited={onExited}>
                    <div className="page-transition__container" style={{ transitionDuration: `${TRANSITION_DURATION}ms` }}>
                        { children }
                    </div>
                </CSSTransition>
            </SwitchTransition>
        </div>
    );
};

export const PageTransition = PageTransitionComponent;
